import { BUSINESS_MENU } from "../config/businessMenu";

/** Flatten menu into unique route segments for <Route> generation */
export const getBusinessFeatureRoutes = () => {
  const seen = new Set();
  const routes = [];

  const add = (path, label) => {
    if (!path || seen.has(path)) return;
    seen.add(path);
    routes.push({ path, label });
  };

  BUSINESS_MENU.forEach((item) => {
    add(item.path, item.label);
    item.children?.forEach((child) => add(child.path, child.label));
  });

  return routes;
};
